// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-page {
  padding-top: 120px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

/* Gallery Filters */
.gallery-filters {
  margin-bottom: 40px;
  text-align: center;
}

.filters-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 20px;
}

.filter-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-bottom: 30px;
}

.filter-btn {
  padding: 10px 20px;
  border: 2px solid #e2e8f0;
  background: #ffffff;
  color: #64748b;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.filter-btn:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.filter-btn.active {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-color: #3b82f6;
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
}

/* Gallery Stats */
.gallery-stats {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 40px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 15px;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.stat-item {
  text-align: center;
}

.stat-number {
  display: block;
  font-size: 2rem;
  font-weight: 800;
  color: #3b82f6;
  line-height: 1;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 0.9rem;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Image Gallery Grid */
.image-gallery {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 60px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.gallery-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.gallery-item:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.image-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.gallery-item:hover .gallery-image {
  transform: scale(1.1);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    transparent 50%,
    rgba(0, 0, 0, 0.8) 100%
  );
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: flex-end;
  padding: 20px;
}

.gallery-item:hover .image-overlay {
  opacity: 1;
}

.overlay-content {
  color: white;
  width: 100%;
}

.image-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1.2;
}

.image-description {
  font-size: 0.85rem;
  opacity: 0.9;
  margin-bottom: 8px;
  line-height: 1.3;
}

.image-category {
  font-size: 0.75rem;
  background: rgba(59, 130, 246, 0.8);
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 500;
}

/* Call to Action */
.gallery-cta {
  text-align: center;
  padding: 40px;
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  border-radius: 20px;
  color: #ffffff;
  margin-top: 60px;
  margin-bottom: 80px;
}

.cta-title {
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 15px;
  color: #ffffff;
}

.cta-description {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 30px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: #ffffff;
  border: none;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

.btn-secondary {
  background: transparent;
  color: #ffffff;
  border: 2px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .image-gallery {
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }
  
  .gallery-stats {
    gap: 35px;
  }
}

@media (max-width: 1024px) {
  .gallery-page {
    padding-top: 110px;
  }
  
  .image-gallery {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .gallery-page {
    padding-top: 100px;
  }
  
  .filters-title {
    font-size: 1.3rem;
    margin-bottom: 18px;
  }
  
  .filter-buttons {
    gap: 8px;
    margin-bottom: 25px;
  }
  
  .filter-btn {
    padding: 8px 16px;
    font-size: 13px;
  }
  
  .gallery-stats {
    gap: 20px;
    padding: 15px;
    margin-bottom: 35px;
  }
  
  .stat-number {
    font-size: 1.5rem;
  }
  
  .stat-label {
    font-size: 0.8rem;
  }
  
  .image-gallery {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    padding: 15px;
    margin-bottom: 40px;
  }
  
  .gallery-item {
    border-radius: 10px;
  }
  
  .image-overlay {
    padding: 15px;
  }
  
  .image-title {
    font-size: 1rem;
  }
  
  .image-description {
    font-size: 0.8rem;
  }
  
  .gallery-cta {
    margin-top: 50px;
    margin-bottom: 60px;
    padding: 35px 25px;
  }
  
  .cta-title {
    font-size: 1.5rem;
    margin-bottom: 12px;
  }
  
  .cta-description {
    font-size: 1rem;
    margin-bottom: 25px;
  }
  
  .cta-buttons {
    gap: 15px;
  }
  
  .btn {
    padding: 10px 20px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .gallery-page {
    padding-top: 80px;
  }
  
  .filters-title {
    font-size: 1.2rem;
    margin-bottom: 15px;
  }
  
  .filter-buttons {
    gap: 6px;
    margin-bottom: 20px;
  }
  
  .filter-btn {
    padding: 6px 12px;
    font-size: 12px;
  }
  
  .gallery-stats {
    flex-direction: column;
    gap: 15px;
    padding: 12px;
    margin-bottom: 30px;
  }
  
  .stat-number {
    font-size: 1.3rem;
  }
  
  .stat-label {
    font-size: 0.75rem;
  }
  
  .image-gallery {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 10px;
    margin-bottom: 35px;
  }
  
  .gallery-item {
    aspect-ratio: 4/3;
    border-radius: 8px;
  }
  
  .image-overlay {
    padding: 12px;
  }
  
  .image-title {
    font-size: 0.9rem;
    margin-bottom: 6px;
  }
  
  .image-description {
    font-size: 0.75rem;
    margin-bottom: 6px;
  }
  
  .image-category {
    font-size: 0.7rem;
    padding: 3px 7px;
  }
  
  .gallery-cta {
    margin-top: 40px;
    margin-bottom: 50px;
    padding: 30px 20px;
  }
  
  .cta-title {
    font-size: 1.3rem;
    margin-bottom: 10px;
  }
  
  .cta-description {
    font-size: 0.9rem;
    margin-bottom: 20px;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
  
  .btn {
    width: 100%;
    max-width: 200px;
    padding: 10px 18px;
    font-size: 12px;
  }
}

@media (max-width: 360px) {
  .gallery-page {
    padding-top: 75px;
  }
  
  .filter-btn {
    padding: 5px 10px;
    font-size: 11px;
  }
  
  .gallery-stats {
    padding: 10px;
  }
  
  .stat-number {
    font-size: 1.2rem;
  }
  
  .image-gallery {
    padding: 8px;
    gap: 10px;
  }
  
  .gallery-cta {
    padding: 25px 15px;
  }
  
  .cta-title {
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Gallery.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;GAKC;EACD,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".gallery-page {\n  padding-top: 120px;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n}\n\n/* Gallery Filters */\n.gallery-filters {\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.filters-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 20px;\n}\n\n.filter-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 30px;\n}\n\n.filter-btn {\n  padding: 10px 20px;\n  border: 2px solid #e2e8f0;\n  background: #ffffff;\n  color: #64748b;\n  border-radius: 25px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.filter-btn:hover {\n  border-color: #3b82f6;\n  color: #3b82f6;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);\n}\n\n.filter-btn.active {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  border-color: #3b82f6;\n  color: #ffffff;\n  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);\n}\n\n/* Gallery Stats */\n.gallery-stats {\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n  margin-bottom: 40px;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 15px;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.stat-item {\n  text-align: center;\n}\n\n.stat-number {\n  display: block;\n  font-size: 2rem;\n  font-weight: 800;\n  color: #3b82f6;\n  line-height: 1;\n  margin-bottom: 4px;\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  color: #64748b;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Image Gallery Grid */\n.image-gallery {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  margin-bottom: 60px;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 20px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n}\n\n.gallery-item {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.gallery-item:hover {\n  transform: translateY(-8px) scale(1.02);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);\n  z-index: 10;\n}\n\n.image-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.gallery-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.gallery-item:hover .gallery-image {\n  transform: scale(1.1);\n}\n\n.image-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    to bottom,\n    transparent 0%,\n    transparent 50%,\n    rgba(0, 0, 0, 0.8) 100%\n  );\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  display: flex;\n  align-items: flex-end;\n  padding: 20px;\n}\n\n.gallery-item:hover .image-overlay {\n  opacity: 1;\n}\n\n.overlay-content {\n  color: white;\n  width: 100%;\n}\n\n.image-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin-bottom: 8px;\n  line-height: 1.2;\n}\n\n.image-description {\n  font-size: 0.85rem;\n  opacity: 0.9;\n  margin-bottom: 8px;\n  line-height: 1.3;\n}\n\n.image-category {\n  font-size: 0.75rem;\n  background: rgba(59, 130, 246, 0.8);\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-weight: 500;\n}\n\n/* Call to Action */\n.gallery-cta {\n  text-align: center;\n  padding: 40px;\n  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);\n  border-radius: 20px;\n  color: #ffffff;\n  margin-top: 60px;\n  margin-bottom: 80px;\n}\n\n.cta-title {\n  font-size: 2rem;\n  font-weight: 800;\n  margin-bottom: 15px;\n  color: #ffffff;\n}\n\n.cta-description {\n  font-size: 1.1rem;\n  color: rgba(255, 255, 255, 0.9);\n  margin-bottom: 30px;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.6;\n}\n\n.cta-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.btn {\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: #ffffff;\n  border: none;\n  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);\n}\n\n.btn-secondary {\n  background: transparent;\n  color: #ffffff;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  backdrop-filter: blur(10px);\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-2px);\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .image-gallery {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 18px;\n  }\n  \n  .gallery-stats {\n    gap: 35px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .gallery-page {\n    padding-top: 110px;\n  }\n  \n  .image-gallery {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .gallery-page {\n    padding-top: 100px;\n  }\n  \n  .filters-title {\n    font-size: 1.3rem;\n    margin-bottom: 18px;\n  }\n  \n  .filter-buttons {\n    gap: 8px;\n    margin-bottom: 25px;\n  }\n  \n  .filter-btn {\n    padding: 8px 16px;\n    font-size: 13px;\n  }\n  \n  .gallery-stats {\n    gap: 20px;\n    padding: 15px;\n    margin-bottom: 35px;\n  }\n  \n  .stat-number {\n    font-size: 1.5rem;\n  }\n  \n  .stat-label {\n    font-size: 0.8rem;\n  }\n  \n  .image-gallery {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n    padding: 15px;\n    margin-bottom: 40px;\n  }\n  \n  .gallery-item {\n    border-radius: 10px;\n  }\n  \n  .image-overlay {\n    padding: 15px;\n  }\n  \n  .image-title {\n    font-size: 1rem;\n  }\n  \n  .image-description {\n    font-size: 0.8rem;\n  }\n  \n  .gallery-cta {\n    margin-top: 50px;\n    margin-bottom: 60px;\n    padding: 35px 25px;\n  }\n  \n  .cta-title {\n    font-size: 1.5rem;\n    margin-bottom: 12px;\n  }\n  \n  .cta-description {\n    font-size: 1rem;\n    margin-bottom: 25px;\n  }\n  \n  .cta-buttons {\n    gap: 15px;\n  }\n  \n  .btn {\n    padding: 10px 20px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .gallery-page {\n    padding-top: 80px;\n  }\n  \n  .filters-title {\n    font-size: 1.2rem;\n    margin-bottom: 15px;\n  }\n  \n  .filter-buttons {\n    gap: 6px;\n    margin-bottom: 20px;\n  }\n  \n  .filter-btn {\n    padding: 6px 12px;\n    font-size: 12px;\n  }\n  \n  .gallery-stats {\n    flex-direction: column;\n    gap: 15px;\n    padding: 12px;\n    margin-bottom: 30px;\n  }\n  \n  .stat-number {\n    font-size: 1.3rem;\n  }\n  \n  .stat-label {\n    font-size: 0.75rem;\n  }\n  \n  .image-gallery {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    padding: 10px;\n    margin-bottom: 35px;\n  }\n  \n  .gallery-item {\n    aspect-ratio: 4/3;\n    border-radius: 8px;\n  }\n  \n  .image-overlay {\n    padding: 12px;\n  }\n  \n  .image-title {\n    font-size: 0.9rem;\n    margin-bottom: 6px;\n  }\n  \n  .image-description {\n    font-size: 0.75rem;\n    margin-bottom: 6px;\n  }\n  \n  .image-category {\n    font-size: 0.7rem;\n    padding: 3px 7px;\n  }\n  \n  .gallery-cta {\n    margin-top: 40px;\n    margin-bottom: 50px;\n    padding: 30px 20px;\n  }\n  \n  .cta-title {\n    font-size: 1.3rem;\n    margin-bottom: 10px;\n  }\n  \n  .cta-description {\n    font-size: 0.9rem;\n    margin-bottom: 20px;\n  }\n  \n  .cta-buttons {\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n  }\n  \n  .btn {\n    width: 100%;\n    max-width: 200px;\n    padding: 10px 18px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 360px) {\n  .gallery-page {\n    padding-top: 75px;\n  }\n  \n  .filter-btn {\n    padding: 5px 10px;\n    font-size: 11px;\n  }\n  \n  .gallery-stats {\n    padding: 10px;\n  }\n  \n  .stat-number {\n    font-size: 1.2rem;\n  }\n  \n  .image-gallery {\n    padding: 8px;\n    gap: 10px;\n  }\n  \n  .gallery-cta {\n    padding: 25px 15px;\n  }\n  \n  .cta-title {\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
